import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { flowRight as compose } from 'lodash';

import cx from 'classnames';
import CommonTable from '../../CommonTable/CommonTable';

import { getAllSmtpData } from '../../../lib/graphql';
import Link from '../../Link/Link';
import { openSmtpSetupModal } from '../../../actions/siteadmin/modalActions';
import { openDeleteSmtpModal, closeDeleteSmtpModal } from "../../../actions/modalActions";
import { deleteSmtpSetup } from '../../../actions/siteadmin/SmtpSetup/manageSmtpData';
import { updateSmtpActiveStatus } from '../../../actions/siteadmin/SmtpSetup/updateSmtpActiveStatus';
import SmtpModal from './SmtpModal/SmtpModal';
import CustomPagination from '../../CustomPagination/CustomPagination';
import { demoRestriction, demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';
import { getCensorFormData } from '../../../helpers/SmtpSetup/getFormData';
import { withQuery } from '../../../hoc/withGraphql';
import DeleteSmtpModal from './SmtpModal/DeleteSmtpModal';
import Loader from '../../Loader/Loader';

import cs from '../../../components/commonStyle.css';
import s from './SmtpManagement.css';
import messages from '../../../locale/jsonMessages';

function SmtpManagement(props) {

    const { data: { refetch, loading, getAllSmtpData }, setStateVariable, openSmtpSetupModal, updateSmtpActiveStatus, currentPage, deleteSmtpSetup, searchList, openDeleteSmtpModal } = props;
    const { closeDeleteSmtpModal } = props;
    const { formatMessage } = props.intl;
    const dispatch = useDispatch();

    const [isDemoRestrict, setRestrict] = useState('false');
    const [deleteLoading, setDeleteLoading] = useState(false);

    useEffect(() => {
        async function fetchData() {
            const isRestrict = await dispatch(demoRestrictionEncode());
            setRestrict(isRestrict);
        }
        fetchData();
    }, []);


    const paginationData = (currentPage) => {
        let variables = { currentPage, searchList };
        setStateVariable(variables);
        refetch(variables);
    }

    const handleModalOpen = (value) => {
        const formData = getCensorFormData(value, isDemoRestrict);
        if (value?.id) openSmtpSetupModal('edit', formData)
        else openSmtpSetupModal('add')
    }

    const handleUpdate = async (id) => {
        const isRestrict = await dispatch(demoRestriction({}));
        if (isRestrict) return;
        await updateSmtpActiveStatus(id);
        let variables = { currentPage: 1, searchList };
        await setStateVariable(variables);
        await refetch(variables);
    }

    const handleDelete = async (id) => {
        setDeleteLoading(true);
        const isRestrict = await dispatch(demoRestriction({ restrictType: 'SMTP', restrictValue: id }));
        if (isRestrict) {
            setDeleteLoading(false);
            await closeDeleteSmtpModal();
            return;
        };
        let variables = { currentPage: currentPage > 1 && getAllSmtpData?.results?.length == 1 ? currentPage - 1 : currentPage, searchList };
        await deleteSmtpSetup({ id });
        setDeleteLoading(false);
        await closeDeleteSmtpModal();
        await setStateVariable(variables);
        await refetch(variables);
    }

    const handleSearchChange = (searchList) => {
        let variables = {
            currentPage: 1,
            searchList,
        };
        setStateVariable(variables);
        refetch(variables);
    }

    const thead = () => {
        return [
            { data: formatMessage(messages.idLabel) },
            { data: formatMessage(messages.smtpName) },
            { data: formatMessage(messages.setActive) },
            { data: formatMessage(messages.status) },
            { data: formatMessage(messages.editLabel) },
            { data: formatMessage(messages.delete) }
        ]
    };

    const tbody = (props) => {
        return getAllSmtpData?.results?.map((value, key) => {
            return {
                id: key,
                data: [
                    { data: value.id },
                    { data: value?.smtpName },
                    { data: !value?.isActive ? <div><Link noLink onClick={() => handleUpdate(value?.id)}><FormattedMessage  {...messages.setAsActive} /></Link></div> : "-" },
                    { data: value?.isActive ? formatMessage(messages.enabledLabel) : formatMessage(messages.disabledLabel) },
                    { data: <div><Link noLink onClick={() => handleModalOpen(value)}><FormattedMessage  {...messages.editLabel} /></Link></div> },
                    {
                        data: <div><Link noLink onClick={() => openDeleteSmtpModal(value.id)}><FormattedMessage  {...messages.delete} /></Link></div>
                    },

                ]
            }
        })
    };

    if (loading) {
        return <Loader type={"text"} />;
    }

    return (
        <div>
            <DeleteSmtpModal handleDelete={handleDelete} deleteLoading={deleteLoading} />
            <SmtpModal paginationData={paginationData} />
            <CommonTable
                thead={thead}
                tbody={() => tbody()}
                isSearch
                onSearch={(e) => handleSearchChange(e?.target?.value)}
                title={formatMessage(messages.smtpCredentialsLabel)}
                isLink
                addAction={handleModalOpen}
                redirectionLabel={formatMessage(messages.addNewLabel)}
            />
            {
                !loading && getAllSmtpData?.count > 0
                &&
                <CustomPagination
                    total={getAllSmtpData.count}
                    currentPage={currentPage}
                    defaultCurrent={1}
                    defaultPageSize={10}
                    change={paginationData}
                    paginationLabel={formatMessage(messages.smtpCredentialsLabel)}
                />

            }
        </div>
    );
}

const mapState = (state) => ({});

const mapDispatch = {
    openSmtpSetupModal,
    deleteSmtpSetup,
    updateSmtpActiveStatus,
    openDeleteSmtpModal,
    closeDeleteSmtpModal
};

SmtpManagement.propTypes = {
    title: PropTypes.string.isRequired,
};

export default compose(
    injectIntl,
    withStyles(cs, s),
    connect(mapState, mapDispatch),
    withQuery(getAllSmtpData, {
        options: (props) => ({
            variables: {
                currentPage: 1,
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    })
)(SmtpManagement);
